import { Box, Chip, styled } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PendingActionsIcon from '@mui/icons-material/PendingActions';

const ChipSpaced = styled(Chip)(({ theme }) => ({
    margin: '2px',
}));

const StatusIndicator = props => {
    return (
        <Box>
            {props.status === 'Approved' && (
                <ChipSpaced
                    data-cy="status"
                    icon={<DoneIcon />}
                    label={props.status}
                    color="primary"
                    variant="outlined"
                    size={props.size}
                />
            )}
            {props.status === 'Pending' && (
                <ChipSpaced
                    data-cy="status"
                    icon={<PendingActionsIcon />}
                    label={props.status}
                    color="primary"
                    variant="outlined"
                    size={props.size}
                />
            )}
            {props.status === 'Cancelled' && (
                <ChipSpaced
                    data-cy="status"
                    icon={<CancelIcon />}
                    label={props.status}
                    color="error"
                    variant="outlined"
                    size={props.size}
                />
            )}
            {(props.status === 'Complete' ||
                props.status === 'Completed' ||
                props.status === 'Processed' ||
                props.status === 'Pending Review') && (
                <ChipSpaced
                    data-cy="status"
                    icon={<DoneAllIcon />}
                    label={props.status}
                    color="primary"
                    variant="outlined"
                    size={props.size}
                />
            )}
        </Box>
    );
};

export default StatusIndicator;
